import { api } from '../../services/api'
import { showSuccess, showError } from '../misc/misc.actions'
import { getBalances, getTransactions } from '../households/households.actions'

export const createCredits = (clientId, payload) => {
	return (dispatch) => {
		dispatch({ type: 'UPDATE_CREDITS' })
		return api
			.post(`/clients/${clientId}/credits/walk`, payload)
			.then((response) => {
				dispatch(showSuccess('Credits added successfully.'))
				dispatch(getBalances(clientId))
				dispatch(getTransactions(clientId))
				dispatch({ type: 'UPDATE_CREDITS_SUCCESS', payload: response.data })
			})
			.catch(() => {
				dispatch(showError('An error occured while adding credits.'))
				dispatch({ type: 'UPDATE_CREDITS_FAIL' })
			})
	}
}

export const deleteCredits = (clientId, payload) => {
	return (dispatch) => {
		dispatch({ type: 'UPDATE_CREDITS' })
		return api
			.post(`/clients/${clientId}/credits/walk/remove`, payload)
			.then((response) => {
				dispatch(showSuccess('Credits removed successfully.'))
				dispatch({ type: 'DELETE_CREDITS_SUCCESS', payload: response.data })
			})
			.catch(() => {
				dispatch(showError('An error occured while removing credits.'))
				dispatch({ type: 'UPDATE_CREDITS_FAIL' })
			})
	}
}
